import React, { useEffect, useState } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import ModalUI from '../UI/ModalUi';
import { translate } from '../../../src/utils/util';
import * as actionLinePicking from '../../../src/actions/linePickingAction';
import LinePickingService from '../../../src/services/LinePickingService';
import JustificationService from '../../../src/services/JustificationService';

const ModalOrderHeader = (props) => {
    const [showConfirm, setShowConfirm] = useState(false);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [openModalReceived, setOpenModalReceived] = useState(false);
    const [redirect, setRedirect] = useState(false);

    useEffect(() => {
        if (openModalReceived) {
            if (!props.justifications?.items || props.justifications?.items?.length === 0) {
                props.getJustifications(props.user.vision, {});
            }
        }
        // eslint-disable-next-line
    }, [openModalReceived]);

    const closeModals = () => {
        setOpenModalReceived(false);
        setOpenModalConfirm(false);
        setShowConfirm(false);
    }

    useEffect(() => {
        if (props.orderReceived.showModalReceivedOrder) {
            setOpenModalReceived(true);
        } else {
            setOpenModalReceived(false);
        }
        // eslint-disable-next-line
    }, [props.orderReceived, props.orderReceived.showModalReceivedOrder]);

    useEffect(() => {
        if (showConfirm) {
            setOpenModalConfirm(true);
        } else {
            setOpenModalConfirm(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showConfirm]);

    const buildOrder = () => {
        let order = props.orderReceived.order;
        order.items = props.missionList;

        return order;
    }

    const startOrderConfirm = () => {
        if (props.missionList.length > 0) {
            props.setSelectedOrder(buildOrder());
            props.startOrder(props.orderReceived.order.orderId);
            props.startOrderItem(props.orderReceived.order.orderId, props.missionList[0]?.orderItemId, () => {
                props.setOrderReceived({
                    order: buildOrder(),
                    showModalReceivedOrder: false
                });
                props.setSelectedMission(props.missionList[0]);
                closeModals();
                setRedirect(true);
            });
        }

        setOpenModalReceived(false);
    }

    const postponeOrder = () => {
        props.postponeOrder(props.orderReceived.order, () => {
            props.addOrder(buildOrder());
            props.setOrderReceived({
                order: buildOrder(),
                showModalReceivedOrder: false,
                updateListMission: !props.orderReceived.updateListMission
            });
            closeModals();
            setRedirect(false);
        });
    }

    const onConfirmModal = () => {
        startOrderConfirm();
        setShowConfirm(false);
        if (props.orderReceived.noHasGroup) {
            props.abandonTask(props.mission.orderId);
            closeModals();
        }
    }

    const onCancel = () => {
        setShowConfirm(false);
        setRedirect(false);
    }

    return (
        <>
            <ModalUI
                open={openModalReceived}
                content={translate('linepicking.received-new-task', 'line-picking')}
                dismissible={false}
                btnCancel={translate('postpone', 'general')}
                title={translate('warning', 'general')}
                onCancel={postponeOrder}
                onConfirm={startOrderConfirm}
            />
            <ModalUI
                open={openModalConfirm}
                content={translate('linepicking.confirm-new-task', 'line-picking')}
                dismissible={false}
                title={translate('warning', 'general')}
                onCancel={onCancel}
                onConfirm={onConfirmModal}
            />
            {
                redirect && (<Redirect
                    to={{
                        pathname: `/linePicking/smallParts/order/missions/${props.missionList[0]?.orderItemId}`,
                        callback: setRedirect
                    }}
                />)
            }
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        showModalConfirmNewTask: state.linePickingReducer.showModalConfirmNewTask,
        orderReceived: state.linePickingReducer.orderReceived,
        missionList: state.pickingReducer.missionList,
        mission: state.linePickingReducer.mission,
        justifications: state.justificationReducer.justifications
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        abandonTask: (orderId) => {
            dispatch(actionLinePicking.setOrderReceived(orderId));
        },
        setOrderReceived: (value) => {
            dispatch(actionLinePicking.setOrderReceived(value));
        },
        postponeOrder: (order, callback) => {
            dispatch(LinePickingService.postponeOrderReceived(order, callback));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(LinePickingService.startOrderItem(orderId, orderItemId, callback));
        },
        setSelectedOrder: (order) => {
            dispatch(actionLinePicking.selectOrder(order));
        },
        startOrder: (orderId, callback) => {
            dispatch(LinePickingService.startOrder(orderId, callback));
        },
        setSelectedMission: (mission) => {
            dispatch(actionLinePicking.selectMission(mission));
        },
        addOrder: (order) => {
            dispatch(actionLinePicking.addOrder(order));
        },
        getJustifications: (vision, filter, pagination) => {
            dispatch(JustificationService.getJustifications(vision, filter, pagination));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)((ModalOrderHeader)));